import React from 'react';
import { Search, LogOut, User } from 'lucide-react';

export default function Topbar({ usuario, nomePerfil, onLogout }) {
  const iniciais = (usuario?.nome || '?')
    .split(/\s+/)
    .map((p) => p.charAt(0))
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <header className="flex items-center gap-4 h-16 px-5 bg-surface border-b border-line/70 shrink-0">
      <div className="flex-1 max-w-xl">
        <div className="relative">
          <Search
            size={16}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-faint pointer-events-none"
          />
          <input
            type="text"
            placeholder="Buscar (em breve)…"
            disabled
            className="input pl-9 bg-surface-muted/60 cursor-not-allowed"
          />
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden sm:flex items-center gap-2.5 px-2 py-1.5 rounded-xl">
          <div className="w-9 h-9 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center text-sm font-semibold">
            {iniciais || <User size={16} />}
          </div>
          <div className="flex flex-col leading-tight">
            <span className="text-sm font-medium text-ink truncate max-w-[160px]">
              {usuario?.nome || 'Usuário'}
            </span>
            <span className="text-[11px] text-ink-subtle">{nomePerfil}</span>
          </div>
        </div>

        <button
          onClick={onLogout}
          className="btn-ghost"
          title="Sair"
        >
          <LogOut size={16} />
          <span className="hidden sm:inline">Sair</span>
        </button>
      </div>
    </header>
  );
}
